<template>
  <div>
    <form class="form-box">
      <b-container class="container-box">
        <b-row class="no-gutters">
          <b-col>
            <h1 class="font-weight-bold text-uppercase">รายละเอียดโปรโมชั่น</h1>
          </b-col>
        </b-row>

        <DetailPanel
          :id="id"
          :form="form"
          :branchInBrand="form.branchInBrand"
          :ddotBranchInBrand="form.ddotBranchInBrand"
          :channelError="channelError"
          :v="$v.form"
          v-on:changeTypePromotion="changeTypePromotion"
          v-if="dataReady"
          ref="detailCollapsePanel"
        />
        <ConditionPanel
          :id="id"
          :form="form"
          :productIdList="productIdAll"
          :productNameList="productNameAll"
          :promotionScope="promotionScope"
          :promotionScopeType="promotionScopeType"
          :filterProductSelectDefault="filterProductSelect"
          :v="$v.form"
          v-on:selectProductList="selectProductList"
          v-on:openProductModal="openProductModal"
          v-on:openUploadFile="openUploadFile"
          v-on:deleteProduct="deleteProduct"
          v-if="dataReady"
          ref="conditionCollapsePanel"
        />
        <DiscountPanel
          :id="id"
          :form="form"
          :productIdList="productIdAll"
          :productNameList="productNameAll"
          :promotionScope="promotionScope"
          :promotionScopeType="[promotionScopeType[0]]"
          :filterProductSelectDefault="filterProductSelect"
          :errorBuyXGetY="errorBuyXGetY"
          :discountProductError="discountProductError"
          :v="$v.form"
          v-on:changeSameScope="changeSameScope"
          v-on:openProductModal="openProductModal"
          v-on:openUploadFile="openUploadFile"
          v-on:deleteProduct="deleteProduct"
          v-if="dataReady"
          ref="DiscountCollapsePanel"
        />

        <ProductModal
          :promotionProductIdList="productIdSelect"
          :promotionProductNameList="productNameSelect"
          :productIdAll="productIdAll"
          :productNameAll="productNameAll"
          v-on:submitProduct="submitProduct"
          ref="ProductListModal"
        />

        <b-row class="mt-5">
          <b-col md="6">
            <b-button
              class="btn btn-main-2 mr-md-2"
              v-if="disableEdit"
              @click="deleteData()"
              :disabled="isDisable"
              >ลบ</b-button
            >
            <b-button
              @click="handleRoute"
              class="btn btn-main-2"
              :disabled="isDisable"
              >ยกเลิก</b-button
            >
          </b-col>
          <b-col md="6" class="text-sm-right">
            <template>
              <button
                type="button"
                class="btn btn-main ml-md-2 text-uppercase"
                :disabled="isDisable"
                @click="checkForm(0)"
              >
                บันทึก
              </button>
            </template>
            <button
              type="button"
              class="btn btn-main ml-md-2 text-uppercase"
              @click="checkForm(1)"
              :disabled="isDisable"
            >
              บันทึกและออก
            </button>
          </b-col>
        </b-row>
      </b-container>
    </form>
    <UploadFile
      textFloat="Import file"
      placeholder="Please choose file"
      format="excel"
      name="file"
      text="*Please upload only file .xlsx less than 10 MB"
      ref="importPromotionInput_1"
      v-on:onFileChange="
        (file) => onFileChangePromotion(file, form.promotion.promotionTypeId)
      "
      :fileName="fileName"
      :style="{ display: 'none' }"
    />

    <ModalAlertConfirm
      msg="ยืนยันการลบ"
      text="คุณแน่ใจหรือไม่ว่าต้องการลบ"
      btnConfirm="ลบ"
      btnCancel="ยกเลิก"
      ref="isModalAlertConfirm"
      @confirm="confirmDelete"
    />
    <ModalAlert
      ref="modalAlert"
      :text="msgModal"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import { required, requiredIf, minValue } from "vuelidate/lib/validators";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import CategoryList from "@/views/pages/promotion/components/CategoryList";
import UploadFile from "@/components/inputs/UploadFile";

import DetailPanel from "./components/detail/DetailPanel.vue";
import ConditionPanel from "./components/condition/ConditionPanel.vue";
import DiscountPanel from "./components/discount/DiscountPanel.vue";
import ProductModal from "./components/productlist/ProductModal.vue";
import defaultForm from "./mockForm.json";
const formString = JSON.stringify(defaultForm.form);
export default {
  name: "PromotionDetails",
  components: {
    ModalAlert,
    ModalAlertConfirm,
    ModalAlertError,
    ModalLoading,
    CategoryList,
    UploadFile,
    DetailPanel,
    ConditionPanel,
    DiscountPanel,
    ProductModal,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
      isDisable: false,
      error: false,
      errorBuyXGetY: false,
      modalAlertShow: false,
      modalMessage: "",
      imageLogoLang: "",
      languageList: [],
      languageActive: 1,
      imgModal: null,
      msgModal: null,
      promotionType: "",
      disableEdit: this.$route.params.id == 0 ? false : true,
      isBusy: false,
      isProduct: false,
      userGroupList: [],
      form: {
        promotion: {
          id: 0,
          sortOrder: 0,
          stopSequence: false,
          startDate: "",
          endDate: "",
          useQuantity: false,
          quantity: 0,
          isCouponCode: false,
          couponCode: null,
          couponQuantity: 0,
          maxUsedPerPerson: 0,
          promotionTypeId: 3,
          memberType: 1,
          channel: {
            dDots: true,
            lazada: false,
            shopee: false,
            jd: false,
            youpik: false,
            zillingo: false,
            brandWebsite: false,
            benToWeb: false,
            channelA: false,
            channelB: false,
          },
          enabled: false,
          useSameCondition: false,
          checkCartCondition: false,
          mainLanguageId: 1,
          isSameLanguage: true,
          translationList: [
            {
              languageId: 1,
              name: null,
            },
            {
              languageId: 2,
              name: null,
            },
          ],
        },
        condition: {
          id: 0,
          minimumTypeId: 0,
          minimumPrice: 0,
          skipPromotionPrice: false,
          weight: 0,
          distance: 0,
          promotionConditionScope: {
            promotionScopeTypeId: 0,
            conditionOperationTypeId: 1,
            productOrCategoryList: [],
            productNameList: [],
            categoryNameList: [],
          },
        },
        privilage: {
          id: 0,
          minimumTypeId: 1,
          minimumPrice: 0,
          skipPromotionPrice: false,
          limitRound: 0,
          promotionConditionScope: {
            promotionScopeTypeId: 0,
            conditionOperationTypeId: 1,
            productOrCategoryList: [],
            productNameList: [],
            categoryNameList: [],
          },
        },
        minimumAmount: {
          id: 0,
          amount: 0,
        },
        appliedProduct: [],
        appliedProductGiftWithPurChase: [],
        branchList: [143],
        branchInBrand: [],
        ddotBranchInBrand: [],
      },
      promotionScope: [
        {
          value: 0,
          text: "All",
        },
        {
          value: 1,
          text: "เลือกรายสินค้า",
        },
      ],
      promotionScopeType: [
        {
          value: 1,
          text: "เลือกรายการสินค้าที่เข้าเงื่อนไข",
        },
        {
          value: 2,
          text: "เลือกรายการสินค้าที่ยกเว้น",
        },
      ],
      filterProductSelect: JSON.stringify(defaultForm.filterProductSelect),
      productIdAll: [],
      productNameAll: [],
      productIdSelect: [],
      productNameSelect: [],
      fileName: "",
      existId: "",
      typeProductModal: "",
      typeUploadFile: "",
      newId: null,
      discountProductError: false,
      channelError: false,
      branchInBrandDefault: [],
      ddotBranchInBrandDefault: [],
      dataReady: false,
    };
  },
  validations: {
    form: {
      promotion: {
        couponCode: {
          required: requiredIf(function () {
            return this.form.promotion.isCouponCode;
          }),
        },
        quantity: {
          required: requiredIf(function () {
            return this.form.promotion.useQuantity;
          }), minValueZero: minValue(0)
        },
        translationList: {
          $each: {
            name: { required },
          },
        },
        startDate: { required },
        endDate: { required },
        sortOrder: { required, minValueZero: minValue(0) },
      },
      condition: {
        minimumPrice: {
          required: requiredIf(function () {
            return (
              this.form.condition.promotionConditionScope
                .promotionScopeTypeId != 0 &&
              this.form.promotion.promotionTypeId == 5
            );
          }), minValueZero: minValue(0)
        },
        promotionConditionScope: {
          productOrCategoryList: {
            required: requiredIf(function () {
              return (
                this.form.condition.promotionConditionScope
                  .productOrCategoryList != [] &&
                this.form.condition.promotionConditionScope
                  .promotionScopeTypeId != 0
              );
            }),
          },
        },
        weight: {
          required: requiredIf(function () {
            return this.form.promotion.promotionTypeId == 7;
          }), minValueZero: minValue(0)
        },
        distance: {
          required: requiredIf(function () {
            return this.form.promotion.promotionTypeId == 7;
          }), minValueZero: minValue(0)
        },
      },
      privilage: {
        minimumPrice: {
          required: requiredIf(function () {
            return (
              this.form.promotion.promotionTypeId != 5 &&
              this.form.promotion.promotionTypeId != 8 &&
              this.form.privilage.minimumTypeId != 6
            );
          }), minValueZero: minValue(0)
        },
        limitRound: {
          minValueZero: minValue(0)
        },
        promotionConditionScope: {
          productOrCategoryList: {
            required: requiredIf(function () {
              return (
                this.form.privilage.promotionConditionScope
                  .productOrCategoryList != [] &&
                this.form.privilage.promotionConditionScope
                  .promotionScopeTypeId != 0
              );
            }),
          },
        },
      },
      minimumAmount: {
        amount: { required , minValueZero: minValue(0) },
      },
      appliedProduct: {
        required: requiredIf(function () {
          return (
            (this.form.promotion.promotionTypeId == 5 || this.form.promotion.promotionTypeId == 6) &&
            this.form.appliedProduct.length == []
          );
        }),
        $each: {
          quantity: { required, minValue: minValue(1) },
        },
      },
    },
  },
  computed: {},
  created: async function () {
    await this.getChannelList();
    //await this.getProductAll();
    this.getUserGroup();
  },
  methods: {
    hasHistory () { return window.history.length > 2 },
    handleRoute(){  
      if(this.hasHistory()) this.$router.push({ path: '/promotion'});
      else this.$router.push({ path: `/product?brandID=${this.$route.query.brandID}` });
    },
    getPromotionDetail() {
      this.isBusy = true;
      this.errorBuyXGetY = false;
      this.axios.get(`${this.$baseUrl}/promotion/${this.id}`).then((data) => {
        if (data.result == 1) {
          this.form = data.detail;
          this.dataReady = true;
          this.isBusy = false;
        }
      });
    },
    async getChannelList() {
      this.isBusy = true;
      this.axios
        .get(`${this.$baseUrl}/promotion/BranchConfig`)
        .then(async (data) => {
          if (data.result == 1) {
            this.branchInBrandDefault = JSON.stringify(
              data.detail.branchInBrand
            );
            this.ddotBranchInBrandDefault = JSON.stringify(
              data.detail.ddotBranchInBrand
            );
            this.form.branchInBrand = JSON.parse(this.branchInBrandDefault);
            this.form.ddotBranchInBrand = JSON.parse(
              this.ddotBranchInBrandDefault
            );
            this.isBusy = false;
            if (this.id == 0) {
              this.dataReady = true;
            } else {
              await this.getPromotionDetail();
              if (
                this.form.promotion.promotionTypeId == 5 ||
                this.form.promotion.promotionTypeId == 6
              ) {
                this.form.privilage.promotionConditionScope.promotionScopeTypeId = 1;
              } else {
                this.form.privilage.promotionConditionScope.promotionScopeTypeId = 0;
              }
            }
          }
        });
    },
    checkForm: async function (flag) {
      this.$refs.DiscountCollapsePanel.setAppliedProduct();

      if (this.form.promotionTypeId == 6) {
        this.form.appliedProductGiftWithPurChase = this.form.appliedProduct;
      }
      this.form.promotion.translationList[1].name =
        this.form.promotion.translationList[0].name;

      if (this.form.branchList.length <= 0) {
        this.channelError = true;
        return;
      }
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }
      if (
        new Date(this.form.promotion.endDate) <
        new Date(this.form.promotion.startDate)
      ) {
        this.error = true;
        return;
      }

      this.error = false;
      this.$refs.modalLoading.show();
      this.modalAlertShow = false;
      this.flag = flag;
      this.submit();
    },
    submit: async function () {
      this.isDisable = true;
      if (this.userGroupList == 1) {
        this.form.promotion.memberType = this.userGroupList[0].id;
      }

      // if (!this.form.appliedProduct.length) {
      //   this.form.appliedProduct = this.form.appliedProductGiftWithPurChase;
      // }

      this.axios
        .post(`${this.$baseUrl}/promotion/save`, this.form)
        .then((data) => {
          this.$refs.modalLoading.hide();
          this.modalAlertShow = true;
          if (data.result == 1) {
            this.newId = data.detail;
            this.msgModal = data.message;
            this.$refs.modalAlert.show();
            if(this.flag == 1) setTimeout(() => { this.handleRoute() }, 3000);
          } else {
            this.modalMessage = data.message;
            this.$refs.modalAlertError.show();
          }
          this.isDisable = false;
        });
    },
    deleteData: async function () {
      this.$refs.isModalAlertConfirm.show();
    },
    confirmDelete() {
      this.axios
        .delete(`${this.$baseUrl}/promotion/remove/${this.id}`)
        .then((data) => {
          if (data.result == 1) {
            this.msgModal = data.message;
            this.$refs.modalAlert.show();

            setTimeout(() => { this.handleRoute() }, 3000);
          }else {
            this.modalMessage = data.message;
            this.$refs.modalAlertError.show();
          }
        });
      this.$refs.isModalAlertConfirm.hide();
    },
    async changeTypePromotion(type) {
      await this.clearConditionDiscount();
      this.form.promotion.promotionTypeId = type;
      if (
        this.form.promotion.promotionTypeId == 5 ||
        this.form.promotion.promotionTypeId == 6
      ) {
        this.form.privilage.promotionConditionScope.promotionScopeTypeId = 1;
      } else {
        this.form.privilage.promotionConditionScope.promotionScopeTypeId = 0;
      }
      this.$refs.detailCollapsePanel.setInit();
    },
    changeSameScope(value) {
      if (value) {
        this.$refs.DiscountCollapsePanel.form.privilage.promotionConditionScope.productOrCategoryList =
          this.$refs.conditionCollapsePanel.form.condition.promotionConditionScope.productOrCategoryList;
        this.$refs.DiscountCollapsePanel.form.privilage.promotionConditionScope.productNameList =
          this.$refs.conditionCollapsePanel.form.condition.promotionConditionScope.productNameList;
        this.$refs.DiscountCollapsePanel.getProductSelect();
      }
    },
    selectProductList() {
      if (this.form.promotion.useSameCondition) {
        this.changeSameScope(true);
      }
    },
    getProductAll() {
      this.axios
        .post(`${this.$baseUrl}/category/getProductList`, {
          type: 1,
          search: "",
          pageNo: 1,
          perPage: 50000,
          isProductInCategory: false,
          productIdList: [],
        })
        .then((data) => {
          if (data.result == 1) {
            data.detail.dataList.forEach((e) => {
              this.productIdAll.push(e.id);
              this.productNameAll.push(e.name);
            });
          }
        });
    },
    getUserGroup() {
      this.axios
        .get(`${this.$baseUrl}/promotion/userGroup`)
        .then((usergroup) => {
          if (usergroup.result == 1) {
            this.userGroupList = usergroup.detail;
          }
        });
    },
    clearConditionDiscount() {
      const productName = this.form.promotion.translationList[0].name;
      this.form = JSON.parse(formString);
      this.form.promotion.translationList[0].name = productName;
      this.form.branchInBrand = JSON.parse(this.branchInBrandDefault);
      this.form.ddotBranchInBrand = JSON.parse(this.ddotBranchInBrandDefault);
      this.$refs.conditionCollapsePanel.filterProductSelect = JSON.parse(
        this.filterProductSelect
      );
      this.$refs.DiscountCollapsePanel.filterProductSelect = JSON.parse(
        this.filterProductSelect
      );
      this.$refs.conditionCollapsePanel.setChangeType();
      this.$refs.DiscountCollapsePanel.setChangeType();
    },
    async openProductModal(type) {
      if (type == "condition") {
        this.productIdSelect =
          this.form.condition.promotionConditionScope.productOrCategoryList;
        this.productNameSelect =
          this.form.condition.promotionConditionScope.productNameList;
      } else {
        this.productIdSelect =
          this.form.privilage.promotionConditionScope.productOrCategoryList;
        this.productNameSelect =
          this.form.privilage.promotionConditionScope.productNameList;
      }
      this.typeProductModal = await type;
      await this.$refs.ProductListModal.show();
    },
    submitProduct(select) {
      if (this.typeProductModal == "condition") {
        this.form.condition.promotionConditionScope.productOrCategoryList =
          select.idList;
        this.form.condition.promotionConditionScope.productNameList =
          select.nameList;
        this.$refs.conditionCollapsePanel.filterProductSelect = {
          type: 1,
          search: "",
          pageNo: 1,
          perPage: 10,
          isProductInCategory: true,
          productIdList: [],
        };
        this.$refs.conditionCollapsePanel.getProductSelect();
        this.selectProductList();
      } else {
        this.form.privilage.promotionConditionScope.productOrCategoryList =
          select.idList;
        this.form.privilage.promotionConditionScope.productNameList =
          select.nameList;
        this.$refs.DiscountCollapsePanel.filterProductSelect = {
          type: 1,
          search: "",
          pageNo: 1,
          perPage: 10,
          isProductInCategory: true,
          productIdList: [],
        };
        this.form.promotion.useSameCondition = false;
        this.$refs.DiscountCollapsePanel.getProductSelect();
      }
    },
    hadleModalAlertClose: function () {
      if (this.flag == 1) {
        this.$router.push({ path: `/promotion` });
      } else {
        if (this.id > 0) {
          this.getPromotionDetail();
        } else {
          this.form.promotion.id = this.newId;
          this.id = this.newId;
          this.$router.push({ path: `/promotion/details/${this.newId}` });
        }
      }
    },
    deleteProduct(data) {
      if (data.type == "condition") {
        this.form.condition.promotionConditionScope.productOrCategoryList.splice(
          data.index,
          1
        );
        this.form.condition.promotionConditionScope.productNameList.splice(
          data.index,
          1
        );
      } else {
        this.form.privilage.promotionConditionScope.productOrCategoryList.splice(
          data.index,
          1
        );
        this.form.privilage.promotionConditionScope.productNameList.splice(
          data.index,
          1
        );
        this.form.appliedProduct.splice(data.index, 1);
      }
    },
    openUploadFile(type) {
      this.typeUploadFile = type;
      this.$refs[`importPromotionInput_1`].$refs.input.click();
    },
    onFileChangePromotion(file, type) {
      this.isBusy = true;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var form = {
          file: reader.result,
        };

        this.axios
          .post(`${this.$baseUrl}/promotion/importProductPromotion`, form)
          .then(async (data) => {
            if (data.result == 1) {
              if (type == 1) {
                this.productlist = [
                  ...this.productlist,
                  ...data.detail.dataList,
                ];
                this.productlist = this.productlist.reduce((acc, current) => {
                  const x = acc.find((item) => item.id === current.id);
                  if (!x) {
                    return acc.concat([current]);
                  } else {
                    return acc;
                  }
                }, []);

                this.form.condition.promotionConditionScope.productNameList =
                  this.productlist.map((product) => product.name);
                this.form.condition.promotionConditionScope.productOrCategoryList =
                  this.productlist.map((product) => product.id);

                this.rows = data.detail.count;
                this.$refs.promotionProductListProduct.selectRow([
                  ...this.productlist,
                  ...data.detail.dataList,
                ]);
              }
              if (type == 2) {
                this.productlistapplied = [
                  ...this.productlistapplied,
                  ...data.detail.dataList,
                ];
                this.productlistapplied = this.productlistapplied.reduce(
                  (acc, current) => {
                    const x = acc.find((item) => item.id === current.id);
                    if (!x) {
                      return acc.concat([current]);
                    } else {
                      return acc;
                    }
                  },
                  []
                );

                this.form.privilage.promotionConditionScope.productNameList =
                  this.productlistapplied.map((product) => product.name);
                this.form.privilage.promotionConditionScope.productOrCategoryList =
                  this.productlistapplied.map((product) => product.id);

                this.rowsApplied = data.detail.count;
                this.$refs.promotionProductListApplied.selectRow([
                  ...this.productlistapplied,
                  ...data.detail.dataList,
                ]);
              }
              if (type == 5 || type == 6) {
                this.form.appliedProduct = [
                  ...this.form.appliedProduct,
                  ...data.detail.dataList,
                ];
                this.form.appliedProduct = this.form.appliedProduct.reduce(
                  (acc, current) => {
                    const x = acc.find((item) => item.id === current.id);
                    if (!x) {
                      return acc.concat([current]);
                    } else {
                      return acc;
                    }
                  },
                  []
                );

                this.buyXgetYProductNameIdList = this.form.appliedProduct.map(
                  (product) => product.name
                );

                this.buyXgetYProductSelectedIdList =
                  this.form.appliedProduct.map((product) => product.id);

                this.rowsbuyXgetY = data.detail.count;

                this.handleChangeIsProductInCategoryBuyXGetY();
              }
            } else {
              alert("Server error", data.detail.toString());
            }
            this.isBusy = false;
          });
      };
    },
  },
};
</script>

<style scoped>
.store-type-box {
  border: 1px solid #bcbcbc;
  height: 130px;
  overflow-y: auto;
}

.radios {
  font-size: 16px;
  line-height: 1.9;
}

.select-txt {
  cursor: pointer;
}

.parent-cat {
  display: inline-block;
  position: relative;
  top: 5px;
  margin-left: 10px;
}

.pl-lv4-cb {
  margin-left: 55px;
}

.category-box {
  height: 300px;
}

.quantity {
  border: 1px solid #d8dbe0;
  text-align: center;
  width: 100px;
  margin: auto;
}

.quantity:focus {
  border: 1px solid #958bef;
}

.label-text {
  width: auto;
}

.tooltip-size {
  font-size: 14px;
}
::v-deep .tooltip-inner {
  text-align: left !important;
  max-width: 300px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000015;
  border-radius: 0.25rem;
}
</style>
